'use strict';

var GetIntrinsic = require('get-intrinsic');

// https://262.ecma-international.org/6.0/#sec-algorithm-conventions

module.exports = GetIntrinsic('%Math.max%');



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-abstract/2016/max.js
// module id = 2052
// module chunks = 0